import Vue from "vue";
import VueRouter from "vue-router";
import dome from "@/router/dome";
Vue.use(VueRouter);

let NotFound = () => import(/* webpackChunkName: "dome" */ "@/views/NotFound");

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  // 解决重复报错的问题
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  // { path: '/:lang', name: 'userlogin', component: userlogin, meta: { isLogin: false } },
  ...dome,
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: { isLogin: true, level: "2,4,999" },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// 前置
router.beforeEach((to, from, next) => {
  const vux = Vue.prototype.$store;
  const langList = vux.state.base.langList;
  const l = vux.state.base.LanguageCode;
  const l2 = to?.params?.lang?.toLowerCase();
  const lang = l2 ? l2 : l;
  console.log("lang::: ", lang, to, from);

  if (langList?.includes(lang)) {
    // 有语言
    if (
      to.path !== `/${lang}/dome` &&
      to.path !== `/${lang}/dome2` &&
      to.path !== `/${lang}/demo2`
    ) {
      // 避免无限递归调用
      next(`/${lang}/dome`);
    } else {
      next(); // 继续导航
    }
  } else {
    // 没有语言的情况下补语言
    if (to.path !== `/${lang}`) {
      // 避免无限递归调用
      next(`/${lang}`);
    } else {
      next(); // 继续导航
    }
  }
});

router.afterEach(() => {});

export default router;
